// extracted by mini-css-extract-plugin
export default {"highlightButton":"HighlightButton_highlightButton__q0g-u"};